import { render } from "./EditProposalComponent.vue?vue&type=template&id=8bb5d726"
import script from "./EditProposalComponent.vue?vue&type=script&lang=js"
export * from "./EditProposalComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__